const status = [
  {
    id: 0,
    label: 'Todos',
    value: 'Todos'
  },
  {
    id: 1,
    label: 'Pedido realizado',
    value: 'Pedido realizado'
  },
  {
    id: 2,
    label: 'Pedido em preparação',
    value: 'Pedido em preparação'
  },
  {
    id: 3,
    label: 'Pedido pronto',
    value: 'Pedido pronto'
  },
  {
    id: 4,
    label: 'Pedido a caminho',
    value: 'Pedido a caminho'
  },
  {
    id: 5,
    label: 'Pedido entregue',
    value: 'Pedido entregue'
  }
]
export default status
